// ─── Channel Builders ────────────────────────────────────
/** Channel for a specific RN — receives their personal events */
export function rnChannel(rnId) {
    return `rn:${rnId}`;
}
/** Broadcast channel — reaches every connected RN */
export function rnAllChannel() {
    return "rn:all";
}
/** Channel for a specific agency — receives agency-scoped events */
export function agencyChannel(agencyId) {
    return `agency:${agencyId}`;
}
/** Broadcast channel — reaches every connected admin */
export function adminAllChannel() {
    return "admin:all";
}
/** Per-run channel for Visit-QA live view. Admin browsers subscribe with
 * qaRunChannel(runId) once they open /agent/[runId]. */
export function qaRunChannel(runId) {
    return `qa-run:${runId}`;
}
//# sourceMappingURL=types.js.map